import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Other Achievements|Catalog|Status Dialog|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	portal: 'SP',
	feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
	htmlAllowed: false,
};

export type SPOtherAchievementCatalogToggleLocNames =
	| 'SPOtherAchievementCatalogActivateTitle'
	| 'SPOtherAchievementCatalogActivateMessage'
	| 'SPOtherAchievementCatalogDeactivateTitle'
	| 'SPOtherAchievementCatalogDeactivateMessage'
	| 'SPOtherAchievementCatalogCancelAction'
	| 'SPOtherAchievementCatalogConfirmAction';

export const spOtherAchievementCatalogToggleLocs: LocDefs<SPOtherAchievementCatalogToggleLocNames> = {
	SPOtherAchievementCatalogActivateTitle: {
		defaultValue: 'Activate Other Achievement',
		description: 'Title for the dialog to activate other achievements',
		displayPath: `${pathStart}Activate Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPOtherAchievementCatalogActivateMessage: {
		defaultValue: 'Please confirm you would like to activate the following other achievement.',
		description: 'Message displayed when activating an other achievement',
		displayPath: `${pathStart}Activate Message`,
		displayType: 'Content',
		shared: false,
		portal: 'SP',
		feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
		htmlAllowed: true,
	},
	SPOtherAchievementCatalogDeactivateTitle: {
		defaultValue: 'Deactivate Other Achievement',
		description: 'Title for the dialog to deactivate other achievements',
		displayPath: `${pathStart}Deactivate Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPOtherAchievementCatalogDeactivateMessage: {
		defaultValue: 'Please confirm you would like to deactivate the following other achievement.',
		description: 'Message displayed when deactivating an other achievement',
		displayPath: `${pathStart}Deactivate Message`,
		displayType: 'Content',
		shared: false,
		portal: 'SP',
		feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
		htmlAllowed: true,
	},
	SPOtherAchievementCatalogCancelAction: {
		defaultValue: 'Cancel',
		description: 'Text for the cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPOtherAchievementCatalogConfirmAction: {
		defaultValue: 'Confirm',
		description: 'Text for the confirm button',
		displayPath: `${pathStart}Confirm`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPOtherAchievementCatalogToggleLocType = LocMap<SPOtherAchievementCatalogToggleLocNames>;
